<template>
  <!--加on为显示烟雾蒙层-->
  <div v-show="isShow" class="guide" :class="{on:smoke}">
    <div v-if="curStep === 'start'" class="start">
      <span
        v-ptt="['btn', 'enterguild', '进入新手引导']"
        class="open"
        @click="next()"
      >点击打开</span>
    </div>
    <div v-else-if="curStep === 'end'" class="end">
      <span class="know" @click="close('finish')">我知道了</span>
    </div>
    <div v-else :class="`step${curStep}`">
      <div class="nextBtn" @click="next()">
        下一步
      </div>
      <div v-show="curStepInfo.isShowCloseBtn" class="jump" @click="close('quit')">
        跳过引导
      </div>
    </div>
  </div>
</template>

<script>
import { localByTime  } from '@utils/storage-time.js';
export default {
  name: 'Guide',
  props: {
    userType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isShow: true,
      stepsList: [
        {
          pageType: 'index',
          pttEname: 'strategyguild',
          pttCname: '攻略引导下一步',
          routeTo: 'map',
          isShowCloseBtn: true,
        },
        {
          pageType: 'map',
          pttEname: 'toolguild',
          pttCname: '工具引导下一步',
          routeTo: 'recommend',
          isShowCloseBtn: false,
        },
        {
          pageType: 'recommend',
          pttEname: 'squareguild',
          pttCname: '广场引导下一步',
          routeTo: 'welfare',
          isShowCloseBtn: false,
        },
        {
          pageType: 'welfare',
          pttEname: 'giftguild',
          pttCname: '福利引导下一步',
          routeTo: 'mine',
          isShowCloseBtn: false,
        },
        {
          pageType: 'mine',
          pttCname: '个人中心引导下一步',
          pttEname: 'personalguild',
          routeTo: 'index',
          isShowCloseBtn: false,
          isEnd: true,
        },
      ],
      curStep: 'start',
      smoke: true, // 开始、结束引导的烟雾蒙层
    };
  },
  computed: {
    curStepInfo() {
      return this.stepsList[this.curStep] || {};
    },
  },
  methods: {
    stop() {
      return false;
    },
    close(type) {
      const curTimestamp = new Date().getTime();
      // 第二天凌晨3点的时间戳
      const endTimestamp =  Number(new Date().setHours(6, 0, 0, 0)
        .toString()) + 86400000;
      localByTime.set('hasSeenGuide', true, endTimestamp - curTimestamp);
      this.isShow = false;
      if (type === 'finish') {
        window.PTTRun && window.PTTSendReport({
          action: 'btn',
          hottag: 'btn_finishguild_完成引导',
          reserved3: 'finishguild',
          fortest1: this.userType,
        });
      } else if (type === 'quit') {
        window.PTTRun && window.PTTSendReport({
          action: 'btn',
          hottag: 'btn_quitguild_跳出引导',
          reserved3: 'quitguild',
          fortest1: this.userType,
        });
      }
    },
    next() {
      setTimeout(() => {
        if (this.curStep === 'start') {
          this.smoke = false;
          this.curStep = 0;
          this.$router.push({ name: 'index' });
          return;
        }
        const { pttEname, pttCname, isEnd, routeTo } = this.curStepInfo;
        PTTSendClick('btn', pttEname, pttCname);
        this.$router.push({
          name: routeTo,
        });
        if (isEnd) {
          this.smoke = true;
          this.curStep = 'end';
          return;
        }
        this.curStep += 1;
      }, 500);
    },
  },
};
</script>

<style lang="scss" src="./index.scss" scoped></style>
